import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';

import { MatterSearchService } from '../../../services/matters/matter-search.service';

@Component({
  selector: 'app-matter-search',
  templateUrl: './matter-search.component.html',
  styleUrls: ['./matter-search.component.css'],
})
export class MatterSearchComponent implements OnInit, OnChanges {
  /**
   * Matter search term
   * @type {string}
   */
  matterSearchTerm: string;

  /**
   * Indicates if include search result item in output
   */
  @Input() include_item: boolean = false;

  /**
   * Matter id for initial selection
   */
  @Input() matterId: number | undefined | null;

  /**
   * Indicates if input size should be small based on bootstrap form-control class
   */
  @Input() small_input: boolean;

  /**
   * Indicates if search should be allowed
   */
  @Input() editable: boolean = true;

  /**
   * Get placeholder from parent component and overrides default in HTML
   */
  @Input() placeholder: string;

  /**
   * Output matter id on matter selection
   * @param {EventEmitter<number> = new EventEmitter(} ) matter_id variable name
   */
  @Output() matter_id: EventEmitter<number> = new EventEmitter();

  /**
   * Indicates if matter selection is only to be sent as output and not show in the HTML
   */
  @Input() select_only: boolean = false;

  /**
   * Output selected matter item from the search results
   * @param {EventEmitter<any>    = new EventEmitter(} ) matter variable name
   */
  @Output() matter: EventEmitter<any> = new EventEmitter();

  /**
   * Outputs if matter selection is to be cleared
   * @param {EventEmitter<any>    = new EventEmitter(} ) clearMatter variable name
   */
  @Output() clearMatter: EventEmitter<any> = new EventEmitter();

  /**
   * Indicates if input matter id changes should also trigger output
   */
  @Input() triggerOnChange: boolean = false;

  /**
   * Constructor
   * @param {MatterSearchService} private matterSearchService Service to access matters controller for search related actions
   */
  constructor(private matterSearchService: MatterSearchService) {}

  /**
   * Called on component initialization
   */
  ngOnInit() {}

  /**
   * Called on changes to component variables
   * @param {any} changes Angular object with variables which have changed
   */
  ngOnChanges(changes: any) {
    if (changes.matterId && changes.matterId.currentValue && (!this.select_only || this.triggerOnChange))
      this.matterSearchService.getMatterInfo(this.matterId!).then((response_json) => {
        if (!this.select_only) this.matterSearchTerm = response_json.name;
        if (this.triggerOnChange) {
          this.matter.emit({
            id: this.matterId,
            label: response_json.name,
            value: this.matterId,
          });
          this.matter_id.emit(Number(this.matterId));
        }
      });
    else if (this.select_only) this.matterSearchTerm = '';
  }

  /**
   * Called to clear selected matter and output to parent component
   */
  clearSelectedMatter(): void {
    this.matterId = undefined;
    this.matterSearchTerm = '';
    this.clearMatter.emit('clearMatter');
  }

  /**
   * Called when matter search result item is selected
   * @param {any} item Search result item as per AutoComplete format of label and value fields
   */
  matterSearchOnSelect(item: any): void {
    if (this.include_item) this.matterId = item.id;
    else this.matterId = item;
    if (this.select_only) {
      let scope = this;
      this.matter.emit(item);
      window.setTimeout(function () {
        scope.matterSearchTerm = '';
      }, 100);
    } else if (this.include_item) {
      this.matter.emit(item);
      this.matter_id.emit(Number(item.id));
    } else this.matter_id.emit(Number(item));
  }
}
